import React, { useState } from "react";
import ListOfJobs from "./Dashboard/ListOfJobs";
import OngoingJobInformation from "./Dashboard/OngoingJobInformation";

const MyJobs = ({ id, setActive, setDetailedTimesheet }) => {
  const [jobId, setJobId] = useState(id ? id : null);
  return jobId === null ? (
    <ListOfJobs setJobId={setJobId} />
  ) : (
    <OngoingJobInformation setDetailedTimesheet={setDetailedTimesheet} setActive={setActive} jobId={jobId} reset={() => setJobId(null)} />
  );
};

export default MyJobs;
